<template>
  <div class="product-details">
    <!-- 1. 图片包裹容器，建立相对定位上下文 -->
    <div class="image-wrapper">
      <img src="../../assets/bg/guize.png" alt="logo" class="bg-image">

      <!-- 2. 内容层，通过相对定位往上移 -->
      <div class="content-layer">

        <!-- 基本产品信息 -->
        <ul class="info-list">
          <li>1、产品名称: 咪咕悦看超级会员</li>
          <li>2、产品资费: 话费支付20元/月</li>
          <li>3、产品对象: 中国移动用户(不含港澳台用户)</li>
        </ul>

        <!-- 重要规则信息 -->
        <ul class="info-list">
          <li>
            4、生效时间:
            支付成功后<span class="highlight">立即生效，有效期3年(36个自然月)。如双方在有效期届满前无异议，有效期自动续展，每次续展3年。合约期：无。有效期内变更/退订/销户/携转，无需承担相应的违约责任。</span>可随时取消，取消<span class="highlight">立即生效</span>，当前周期内可继续享受权益，次月起不再扣费。
          </li>
          <li>
            5、产品权益:
           可享咪咕悦看APP内<span class="highlight">全库短剧、漫剧畅看、全库图书畅读、全库有声书畅听等权益(特殊版权内容除外)。</span>更详细权益介绍可至咪咕悦看APP会员界面查看。
          </li>
          <li>
            6、权益领取:
            订购成功后，权益无需客户领取，立即直充到账，<span class="highlight">请下载咪咕悦看APP</span>，用订购手机号登录即可使用。
          </li>
        </ul>

        <!-- 其他补充说明信息 -->
        <ul class="info-list">
          <li>
            <span class="highlight"> 7、叠加规则:
              同一连续包月产品，每个用户每月仅能订购一次。<br>
              (1) 话费支付订购同一连续包月产品，每月仅限1次，当月取消，次月才可再次话费订购。<br>
              (2) 订购同一产品的不同周期，时长可叠加。<br>
              (3) 订购不同产品时，时长叠加规则如下:<br>
              &nbsp;&nbsp;&nbsp;&nbsp;① 悦看超级、悦读黄金、悦读尊享、悦读畅享会员可互相叠加。<br>
              &nbsp;&nbsp;&nbsp;&nbsp;② 悦看标准与悦看超级、悦读黄金、悦读尊享可互相叠加(不与悦读畅享会员叠加，并行生效)。<br>
              &nbsp;&nbsp;&nbsp;&nbsp;③ 生效优先级从高到低为:悦看超级会员>悦读黄金会员>悦读尊享会员>悦看标准会员=悦读畅享会员。
            </span>
          </li>
          <li>
            8、办理须知:
           订购业务前请仔细阅读业务规则，订购本业务，即视为同意接受本业务及所有条款或规则。
          </li>
          <li>
            9、<span class="highlight">业务退订渠道:
              所属省份10086热线、当地中国移动营业厅、中国移动APP。</span>
          </li>
          <li>
            10、不可抗力:
            如发生不可抗力、情势变更情形(包括但不限于因自然灾害、司法行政命令、公共服务故障、设备与系统维护或故障、网络信息与数据安全、外呼电话无法联系用户等)造成您订购、兑换、使用或变更相关权益障碍、延后或内容变更等情形，我们可依据法律法规的规定主张免责、采取适当应对措施。
          </li>
          <li>
            11、客服咨询:<br>
            (1)客服热线:4001009886，客服工作时间:周一到周日8:00-21:00，节假日无休；<br>
            (2)在线客服:咪咕悦看APP-我的-右上角耳机图标-联系客服，工作时间:周一到周日08:30-22:00，节假日无休。
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
// 采用静态模板方式，不再需要引入响应式数据
</script>

<style scoped>
/* 核心容器：限制宽度，加上圆角和溢出隐藏 */
.product-details {
  font-size: 16px;
  color: #333;
  max-width: 800px;
  margin: 20px auto;
  padding: 0;
  border-radius: 8px;
  overflow: hidden;
}

/* 新增：图片包裹容器，建立相对定位上下文 */
.image-wrapper {
  position: relative;
  width: 100%;
}

/* 背景图：设置为块级元素，消除底部默认间隙 */
.bg-image {
  display: block;
  width: 100%;
  height: auto;
}

/* 内容层：使用相对定位向上偏移，压住图片底部 */
.content-layer {
  position: relative;
  top: -15px; /* 相对于自身原本位置向上移动 30px */
  margin-left: 5px;
  margin-right: 5px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 15px;
}

/* 列表通用样式 */
.info-list {
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
}

.info-list:last-child {
  margin-bottom: 0;
}

.info-list li {
  margin-bottom: 10px;
  line-height: 1.6;
}

/* 重点文字高亮样式 */
.highlight {
  color: #ff460f;
  font-weight: bold;
  padding: 0 2px;
}
</style>
